import firebase from "firebase";
import Constants from "./utils/Constants";

let db = null;
let auth = null;


const init = () => {
    // const firebaseConfig = {
    //     apiKey: "AIzaSyBJK9UUD5BxSdYMInS8OJBWFLjUnTU_srs",
    //     authDomain: "burb-89d4c.firebaseapp.com",
    //     databaseURL: "https://burb-89d4c.firebaseio.com",
    //     projectId: "burb-89d4c",
    //     storageBucket: "burb-89d4c.appspot.com",
    //     messagingSenderId: "279592480584",
    //     appId: "1:279592480584:web:ff061e663171731323cd7d",
    //     measurementId: "G-1371P3P2LT"
    // };

    const firebaseConfig = {
        apiKey: "AIzaSyBBFn3Q1TTPYTxbYeRAHtsY6TEv27_RHyc",
        authDomain: "test-9d005.firebaseapp.com",
        databaseURL: "https://test-9d005.firebaseio.com",
        projectId: "test-9d005",
        storageBucket: "test-9d005.appspot.com",
        messagingSenderId: "166448965898",
        appId: "1:166448965898:web:1f69aadc410018180db2f3",
        // measurementId: "G-1371P3P2LT"
    };

    firebase.initializeApp(firebaseConfig);

    db = firebase.firestore()
    auth = firebase.auth()
}

/**
 * @param emailID
 * @param password
 * This method is used to login the user.
 */
function login(emailID, password) {
    return auth.signInWithEmailAndPassword(emailID, password).then(res => {
        return res
    })
}

/**
 * This method is used to logout the user.
 */
function logout() {
    return auth.signOut().then(res => {
        return res;
    })
}

function addData(collectionName, obj, namesData) {
    let batch = db.batch();
    const id = db.collection(collectionName).doc().id
    obj.id = id
    obj.created_at = new Date().getTime()
    return db.collection(collectionName).doc(id).set(obj).then((querySnapshot) => {
        if (namesData && namesData.length > 0) {
            namesData.forEach((element, index) => {
                if (index < 300) {
                    const docId = db.collection(collectionName).doc().collection(Constants.names).doc().id
                    var pRef = db.collection(Constants.subcategoryCollection).doc(id).collection(Constants.names).doc(docId);
                    element.id = docId
                    element.created_at = new Date().getTime()
                    batch.set(pRef, element);
                }
            });
            batch.commit().then(() => {
                return querySnapshot
            });
        }
    });
}

function updateData(collectionName, obj, namesData) {
    let batch = db.batch();
    obj.updated_at = new Date().getTime()
    return db.collection(collectionName).doc(obj.id).set(obj, { merge: true }).then((querySnapshot) => {
        if (namesData && namesData.length > 0) {
            namesData.forEach((element, index) => {
                if (index < 300) {
                    const docId = db.collection(collectionName).doc().collection(Constants.names).doc().id
                    var pRef = db.collection(Constants.subcategoryCollection).doc(obj.id).collection(Constants.names).doc(docId);
                    element.id = docId
                    element.created_at = new Date().getTime()
                    batch.set(pRef, element);
                }
            });
            batch.commit().then(() => {
                return querySnapshot
            });
        }
        if (collectionName === Constants.categoryCollection) {
            let batch1 = db.batch();
            return db.collection(Constants.subcategoryCollection).where("category_id", "==", obj.id).get().then(async (querySnapshot) => {
                const length = querySnapshot.docs.length
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    let tempObj = querySnapshot.docs[i].data();
                    let sRef = db.collection(Constants.subcategoryCollection).doc(querySnapshot.docs[i].id);
                    tempObj.category_name = obj.name;
                    batch1.set(sRef, tempObj, { merge: true });
                    if ((i + 1) % 499 === 0) {
                        console.log('Call commit')
                        await batch1.commit()
                        console.log('res', i)
                        batch1 = db.batch();
                    }
                }
                // querySnapshot.docs.map((tempData) => {
                //     let tempObj = tempData.data();
                //     let sRef = db.collection(Constants.subcategoryCollection).doc(tempData.id);
                //     tempObj.category_name = obj.name;
                //     batch1.set(sRef, tempObj, { merge: true });
                // })
                if ((length % 499) !== 0) {
                    batch1.commit().then((querySnapshot) => {
                        console.log('Called final commit')
                        return querySnapshot
                    });
                } else {
                    return querySnapshot
                }
            })
        }
    });
}

function deleteCategory(id) {
    return db.collection(Constants.subcategoryCollection).where("category_id", "==", id).get().then((querySnapshot) => {
        console.log('querySnapshot', querySnapshot)
        return querySnapshot
    })
}

function deleteData(collectionName, id) {
    return db.collection(collectionName).doc(id).delete().then(querySnapshot => {
        return querySnapshot
    })
}

function deleteSubCategotyData(id) {
    let batch = db.batch();
    return db.collection(Constants.subcategoryCollection).doc(id).collection(Constants.names).get().then(async (querySnapshot) => {
        // querySnapshot.docs.map((tempData) => {
        //     let dRef = db.collection(Constants.subcategoryCollection).doc(id).collection(Constants.names).doc(tempData.id);
        //     batch.delete(dRef);
        // })
        const length = querySnapshot.docs.length
        for (let i = 0; i < querySnapshot.docs.length; i++) {
            let tempObj = querySnapshot.docs[i].data();
            let dRef = db.collection(Constants.subcategoryCollection).doc(id).collection(Constants.names).doc(tempObj.id);
            batch.delete(dRef);
            if ((i + 1) % 499 === 0) {
                console.log('Call commit')
                await batch.commit()
                console.log('res', i)
                batch = db.batch();
            }
        }
        if ((length % 499) !== 0) {
            return batch.commit().then((querySnapshot) => {
                console.log('Called final commit')
                return deleteData(Constants.subcategoryCollection, id)
            });
        } else {
            return deleteData(Constants.subcategoryCollection, id)
        }
    })
}

const deleteMultipleSubCategory = async (data) => {
    for (let i = 0; i < data.length; i++) {
        let tempObj = data[i];
        await deleteSubCategotyData(tempObj.id)
    }
}

const addSlogansData = async (slogansData, obj, callback) => {
    let batch = db.batch();
    let length = slogansData.length;
    if (slogansData && slogansData.length > 0) {
        for (let i = 0; i < slogansData.length; i++) {
            const docId = db.collection(Constants.slogan).doc().id
            let pRef = db.collection(Constants.slogan).doc(docId);
            slogansData[i].id = docId
            slogansData[i].created_at = new Date().getTime()
            slogansData[i].slogan_category_name = obj.slogan_category_name
            slogansData[i].slogan_category_id = obj.slogan_category_id
            await batch.set(pRef, slogansData[i])
            if ((i + 1) % 499 === 0) {
                console.log('Call commit')
                await batch.commit()
                console.log('res', i)
                batch = db.batch();
            }
        }
        if ((length % 499) !== 0) {
            batch.commit().then((querySnapshot) => {
                callback(querySnapshot)
                console.log('Called final commit')
            });
        } else {
            callback()
        }
    }
}

function getDataCheckExistEmailID(email) {
    return db.collection(Constants.adminCollection).where("email", "==", email).get().then((querySnapshot) => {
        return querySnapshot
    });
}

function getData(collectionName) {
    return db.collection(collectionName).get().then((querySnapshot) => {
        return querySnapshot
    });
}

function statusUpdate(collectionName, userId, value) {
    return db.collection(collectionName).doc(userId).update({ enable: value }).then((querySnapshot) => {
        return querySnapshot
    });
}

function getDataByDocId(collectionName, userId) {
    return db.collection(collectionName).doc(userId).get().then((querySnapshot) => {
        return querySnapshot
    });
}

function updatePaymentStatus(value, item) {
    delete item.index
    delete item.createdAt
    let objectRef = db.collection(Constants.paymentCollection).doc(item.user_id)
    return objectRef.update({
        [item.id]: {
            ...item,
            status: value
        }
    });
}

export {
    init,
    login,
    logout,
    addData,
    deleteData,
    deleteCategory,
    deleteMultipleSubCategory,
    updateData,
    deleteSubCategotyData,
    addSlogansData,
    getDataCheckExistEmailID,
    getData,
    statusUpdate,
    getDataByDocId,
    updatePaymentStatus,
}